import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import api from "../../api";
import { PageTitle, Badge } from "./AdminLayout";

const LEVEL_TONE = { INFO: "green", WARN: "amber", ERROR: "red" };

export default function LogsAdmin() {
  const [logs, setLogs] = useState([]);
  const [level, setLevel] = useState("");
  const [q, setQ] = useState("");

  const load = () => {
    const params = new URLSearchParams();
    if (level) params.set("level", level);
    if (q) params.set("q", q);
    api.get(`/admin/logs?${params}`).then((r) => setLogs(r.data)).catch(() => {});
  };
  useEffect(() => { load(); }, [level]); // eslint-disable-line

  return (
    <div data-testid="admin-logs">
      <PageTitle title="System Logs" sub="Gateway, music nodes, commands and auth events." />
      <div className="flex flex-wrap items-center gap-3 mb-6">
        <div className="flex gap-2" data-testid="logs-level-filter">
          {["", "INFO", "WARN", "ERROR"].map((l) => (
            <button key={l || "all"} onClick={() => setLevel(l)} data-testid={`logs-level-${l || "all"}`}
              className={`px-4 py-2 rounded-full text-xs font-mono font-semibold transition-colors duration-150 ${level === l ? "bg-blurple text-white" : "border border-white/15 text-white/50 hover:text-white"}`}>
              {l || "ALL"}
            </button>
          ))}
        </div>
        <form onSubmit={(e) => { e.preventDefault(); load(); }} className="relative flex-1 max-w-sm">
          <Search size={14} className="absolute left-4 top-1/2 -translate-y-1/2 text-white/40" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search log messages…" data-testid="logs-search"
            className="w-full bg-white/5 border border-white/10 rounded-full pl-10 pr-4 py-2 text-sm text-white focus:outline-none focus:ring-2 focus:ring-blurple" />
        </form>
      </div>

      <div className="rounded-lg border border-white/5 bg-panel p-4 font-mono text-xs space-y-1.5 max-h-[70vh] overflow-y-auto scanlines" data-testid="logs-list">
        {logs.map((l) => (
          <div key={l.id} className="flex gap-3 items-baseline hover:bg-white/[0.02] px-2 py-1 rounded">
            <span className="text-white/25 shrink-0">{new Date(l.ts).toLocaleTimeString()}</span>
            <Badge tone={LEVEL_TONE[l.level] || "grey"}>{l.level}</Badge>
            <span className="text-volt/70 shrink-0">{l.source}</span>
            <span className="text-white/75">{l.message}</span>
          </div>
        ))}
        {!logs.length && <p className="text-white/30 px-2 py-4">No logs match.</p>}
      </div>
    </div>
  );
}
